
import { GET_DPP_DURABILITY_FAILURE, GET_DPP_DURABILITY_REQUEST, GET_DPP_DURABILITY_SUCCESS } from "./durabilityTypes";

const initialState = {
  loading: false,
  durability: [],
  error: "",
};

const getDppDurabilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DPP_DURABILITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DPP_DURABILITY_SUCCESS:
      return {
        loading: false,
        durability: action.payload,
        error: "",
      };
    case GET_DPP_DURABILITY_FAILURE:
      return {
        loading: false,
        durability: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

// const initialStateWithPagination = {
//   loading: false,
//   documentType: [],
//   error: "",
// };

// const getDocumentTypeWithPaginationReducer = (
//   state = initialStateWithPagination,
//   action
// ) => {
//   switch (action.type) {
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS:
//       return {
//         loading: false,
//         documentType: action.payload,
//         error: "",
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE:
//       return {
//         loading: false,
//         documentType: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

export { getDppDurabilityReducer,
    //  getDocumentTypeWithPaginationReducer 
    };
